import { Link } from 'react-router-dom';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { LOGO_URL, PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL } from '../data/content';

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#1E293B] bg-[#0A1128]">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid gap-12 md:grid-cols-3">
      <div>
        <img src="/logo.png" alt="Vira Nakliyat" className="h-12 w-auto object-contain mb-6" />
        <p className="text-[#A0ABC0] text-sm leading-relaxed max-w-xs">
          İnegöl&apos;den Türkiye&apos;nin 81 iline, tüm illerden yeni yuvanıza. Sigortalı ve
          asansörlü evden eve nakliyat.
        </p>
      </div>

      <div>
        <h4 className="font-display text-sm uppercase tracking-[0.25em] text-[#F2F4F8] mb-6">
          Sayfalar
        </h4>
        <ul className="space-y-3">
          {[
            { to: '/', label: 'Ana Sayfa' },
            { to: '/hizmetler', label: 'Hizmetler' },
            { to: '/hakkimizda', label: 'Hakkımızda' },
            { to: '/iletisim', label: 'İletişim' },
          ].map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.to === '/' ? 'home' : l.to.slice(1)}`}
                className="text-[#A0ABC0] hover:text-[#FF5C00] text-sm transition-colors duration-300"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-display text-sm uppercase tracking-[0.25em] text-[#F2F4F8] mb-6">
          İletişim
        </h4>
        <ul className="space-y-4 text-sm">
          <li>
            <a
              href={PHONE_TEL}
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-[#F2F4F8] hover:text-[#FF5C00] transition-colors duration-300"
            >
              <Phone size={16} className="text-[#FF5C00]" /> {PHONE_DISPLAY}
            </a>
          </li>
          <li>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-3 text-[#F2F4F8] hover:text-[#FF5C00] transition-colors duration-300"
            >
              <MessageCircle size={16} className="text-[#FF5C00]" /> WhatsApp Hattı
            </a>
          </li>
          <li className="flex items-center gap-3 text-[#A0ABC0]">
            <MapPin size={16} className="text-[#FF5C00]" /> İnegöl / Bursa — Türkiye Geneli
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-[#A0ABC0] tracking-wide">
          © {new Date().getFullYear()} Vira Nakliyat. Tüm hakları saklıdır.
        </p>
        <p className="text-xs text-[#A0ABC0] tracking-[0.2em] uppercase">
          İnegöl&apos;den Tüm Türkiye&apos;ye
        </p>
      </div>
    </div>
  </footer>
);
